<div [ngClass]="getStyleClass()" class="text-xs font-medium border-round-sm flex align-items-center px-2 py-1 gap-1 rem-text-default rem-chip">
    <i class="pi pi-{{icon}} text-xs font-medium"></i>
    <span>{{label}}</span>
</div>